import angular from 'angular';
import uiPagination from 'angular-ui-bootstrap/src/pagination';
import uiModal from 'angular-ui-bootstrap/src/modal';
import {crud} from '../common/crud/crud.js';
import {CjenikComponent} from './cjenik.component.js';
import {CardCjenikComponent} from './cardCjenik.component.js';
import {StavkaCjenikaComponent} from './stavkaCjenika.component.js';

const cjenik = angular.module('cjenik', [uiPagination, uiModal, crud.name]);

cjenik.component('cjenik', CjenikComponent);
cjenik.component('cardCjenik', CardCjenikComponent);
cjenik.component('stavkaCjenika', StavkaCjenikaComponent);

export {cjenik};



// WEBPACK FOOTER //
// ./app/components/cjenik/cjenik.js